import { useReadPermission } from 'hooks/useUserRoles';
import { PermissionCode } from 'data/UserPermissions';

export const useServicePermissions = () => {
    const { readOnly: readOnlyEdit } = useReadPermission(PermissionCode.EDIT_ADDON_DETAILS);
    const { readOnly: readOnlyCreate } = useReadPermission(PermissionCode.ADDONS_CREATE);

    // If current path includes /new-addon, we are in create mode
    const isCreateMode = window.location.pathname.includes('/new-addon');
    const readOnly = isCreateMode ? readOnlyCreate : readOnlyEdit;

    return {
        isCreateMode,
        readOnly,
        readOnlyEdit,
        readOnlyCreate
    };
};
